import AppRoutes from './util/Routes';
import Config from './config/config';

import './App.css';

function App() {
  return (
    <>
      <Config />
      <AppRoutes />
    </>
  );
}

export default App;
